import {Component, OnInit, AfterViewInit, EventEmitter, Output, Input} from '@angular/core';
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";

declare var jquery:any;
declare var $ :any;

@Component({
    selector: 'app-activity-introduction',
    templateUrl: './activity-introduction.component.html',
    styleUrls: ['./activity-introduction.component.css',]
})
export class ActivityIntroductionComponent implements OnInit , AfterViewInit  {
    showButton: boolean;
    choiceBtnDisable: boolean;
    choiceBtnText: string;
    @Input() practiceMetaId: number;

    newEdition:boolean;

    @Output() onApply = new EventEmitter<boolean>();

    constructor(private apiService: ApiService,
      private router: Router) { }

    ngOnInit() {
        this.showButton = false;
        if (this.practiceMetaId > 0) {
            this.showButton = true;
            this.choiceBtnDisable = false;
            this.choiceBtnText = "我也试试";
        }
        else {
            this.apiService.checkRegister().subscribe(result => {
                this.showButton = true;
                if (result.isRegistered == true) {
                    this.choiceBtnDisable = true;
                    this.choiceBtnText = "已申请";

                }
                else {
                    this.choiceBtnDisable = false;
                    this.choiceBtnText = "申请试用";
                }
            });
        }

        this.newEdition = true;
    }

    ngAfterViewInit(){

        if(!this.newEdition){
          let html=document.documentElement;
          /*var htmlFontSize=html.clientWidth/7.5;*/
          let htmlFontSize;
          if(window.screen.width<window.screen.height){
            htmlFontSize = window.screen.width/ 7.5;
          }else{
            htmlFontSize = window.screen.height/ 7.5;
          }
          html.style.fontSize=htmlFontSize+"px";
          html.style.backgroundColor="#2c2c50";

          let boxHeight = document.getElementById("text_box_1").offsetHeight;

          let wrapHeight = document.documentElement.offsetHeight - 0.98*htmlFontSize;
          $("#wrap").height(wrapHeight);
        }else{
          window.sessionStorage.setItem('newEdition','newEdition');
        }
    }

    register() {
        if (!this.choiceBtnDisable) {
          let link = ['form', '3'];
          this.router.navigate(link);

            this.apiService.onApply().subscribe(result => {
            });
        }
        /*this.onApply.emit(true);*/
    }
}



// WEBPACK FOOTER //
// ./src/app/activity-introduction/activity-introduction.component.ts